exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Auth__Container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100vh; }\n  .Auth__Container h1 {\n    font-size: 48px;\n    color: #fff;\n    font-weight: bold;\n    text-align: center;\n    margin-bottom: 70px; }\n\n.Auth button {\n  width: 170px;\n  text-transform: uppercase;\n  margin-top: 5rem; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/SuperAdmin/Auth/Auth.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/pages/SuperAdmin/Auth/Auth.css
// module chunks = 0